export function cycleCircularArray<T>(arr: Array<T>, currentValue: T) {
  const currentPosition = arr.indexOf(currentValue)
  if (currentPosition === arr.length - 1) return arr[0]
  return arr[currentPosition + 1]
}
